import { Component, OnInit, Input, AfterViewInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { LogonTypeEnum, PreAuthenticationResponse, LogonRequest, PrivateDataModel, RegisterRequestModel, ApiKeys, MediaDataModel, LogonResponse, PermissionType, UsersModel } from '@picard/models-lib';
import { validateEmail, StorageConstants } from '@picard/shared-lib';
import { AuthenticationService, PreAuthenticationService, ApplicationService } from '@picard/services-lib';
import { MessageService } from 'primeng/primeng';
import Swal from 'sweetalert2';
import { isNullOrUndefined } from 'util';
import { Title } from '@angular/platform-browser';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { BlockUI, NgBlockUI } from 'ng-block-ui';
declare var window: any;
declare var FB: any;
declare const gapi: any;
// ToDo: Regesign all this
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {
  //#region Properties
  preAuthenticationResponse: PreAuthenticationResponse;
  authenticationBeansAsyncResponse: PreAuthenticationResponse;
  logonTypeEnum: any = LogonTypeEnum;
  logonRequest: LogonRequest;
  privateDataModel: PrivateDataModel;
  registerValue: string;
  partnerCode: string;
  userData: MediaDataModel;
  loggedIn: boolean;
  auth2: any;
  settings: ApiKeys;
  logonResponse: LogonResponse;
  mobileNumberFormGroup: FormGroup;
  emailFormGroup: FormGroup;
  shortCode: string;
  @BlockUI() blockUI: NgBlockUI;
  programId: number;


  beansUser: UsersModel;
  //#endregion Properties

  //#region Constructor
  constructor(public _authenticationService: AuthenticationService, /*private _platformService: PlatformService,*/ private _router: Router, private _messageService: MessageService, private _activatedRoute: ActivatedRoute, private _preAuthenticationService: PreAuthenticationService, private _applicationService: ApplicationService, private _title: Title, private _formBuilder: FormBuilder) {
    this.programId = parseInt(sessionStorage.getItem('programID')); // this._applicationService.preAuthenticationResponse.programId;
   }
  //#endregion Constructor

  //#region Functions
  ngOnInit() {
    this.privateDataModel = new PrivateDataModel();
    if (isNullOrUndefined(sessionStorage.getItem(StorageConstants.MediaAuthInit))) {
      sessionStorage.setItem(StorageConstants.MediaAuthInit, 'false');
    }
    this._messageService.clear();
    sessionStorage.removeItem(StorageConstants.loginDetails);
    this._applicationService.setFavIcon();
    this._activatedRoute.queryParams.subscribe((params: Params) => (this.partnerCode = params['partner']));
  }
  setPrivateData(val: any, isPassword: boolean): void {
    if (isPassword) {
      this.privateDataModel.password = val;
    } else {
      this.privateDataModel.typeValue = val;
    }
  }
  async ngAfterViewInit() {
    const hostInformation = location.hostname.split('.', 3);
    if (hostInformation[0].toLowerCase() !== 'localhost') {
      this.partnerCode = hostInformation[0];
      if (location.hostname.includes('loyalty.ngf')){
        this.partnerCode = 'norman';
      }
    }
    const preAuthResponse = await this._preAuthenticationService.PreAuthenticationAsync(this.partnerCode);
    sessionStorage.setItem(StorageConstants.preAuth, JSON.stringify(preAuthResponse));

    if (!this.partnerCode.includes('pvtk') && preAuthResponse.programId === 2222) {
      const preAuthResponseBeans = await this._preAuthenticationService.PreAuthenticationAsync('scbn');
      sessionStorage.setItem('preAuthBeans', JSON.stringify(preAuthResponseBeans));
    }

    const preAuthJson = sessionStorage.getItem(StorageConstants.preAuth);
    this.preAuthenticationResponse = JSON.parse(preAuthJson);
    if (this.preAuthenticationResponse.loginType === 2) {
      this.mobileNumberFormGroup = this._formBuilder.group({
        mobileNumber: ['', Validators.required],
        password: ['', Validators.required]
      });
      const mobileNumber = this.mobileNumberFormGroup.get('mobileNumber');
      mobileNumber.valueChanges.subscribe((value: string) => this.setPrivateData(value, false));
      const password = this.mobileNumberFormGroup.get('password');
      password.valueChanges.subscribe((value: string) => this.setPrivateData(value, true));
    }
    if (this.preAuthenticationResponse.loginType === 1) {
      this.emailFormGroup = this._formBuilder.group({
        email: ['', Validators.required],
        password: ['', Validators.required]
      });
      const email = this.emailFormGroup.get('email');
      email.valueChanges.subscribe((value: string) => this.setPrivateData(value, false));
      const password = this.emailFormGroup.get('password');
      password.valueChanges.subscribe((value: string) => this.setPrivateData(value, true));
    }
    const htmlBody: HTMLLinkElement = <HTMLLinkElement>document.getElementById('picard-body');
    if (htmlBody !== null) {
      htmlBody.className = 'login-body';
      htmlBody.style.backgroundImage = `url("${this.preAuthenticationResponse.programmeAssetsModel.imageAssetsModel.bodyUrl}")`;
    }
    this._title.setTitle(`${this.preAuthenticationResponse.description} - Login`);
    this.settings = JSON.parse(sessionStorage['application-settings']).apiKeys;
    if (this.preAuthenticationResponse.loginType === LogonTypeEnum.SocialMedia) {
      this.googleInit();
      // This function initializes the FB variable
      this.InitFB();
    }
    const doc = document.getElementById('appFavicon');
    if (doc) {
      doc.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.imageAssetsModel.favIconUrl);
    }
    const docTheme = document.getElementById('theme-css');
    if (docTheme) {
      docTheme.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.theme);
    }
    const docLayout = document.getElementById('layout-css');
    if (docLayout) {
      docLayout.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.layout);
    }
  }
  async onLogin() {
    let programmesShortCode = this.partnerCode;
    if (this.preAuthenticationResponse.showLinkedProgrammes) {
      if (this.shortCode === '' || (this.shortCode === null || this.shortCode === undefined)) {
        Swal({ type: 'warning', title: 'Please ensure to enter a short code value.', showConfirmButton: false, timer: 2000 });
        return;
      } else {
        programmesShortCode = this.shortCode;
      }
    } else {
      programmesShortCode = this.partnerCode;
    }
    if (this.preAuthenticationResponse.loginType === LogonTypeEnum.SocialMedia) {
      if (window.FB) {
        window.FB.XFBML.parse();
      }
    }
    if (this.preAuthenticationResponse) {
      this.logonRequest = new LogonRequest();
      this.privateDataModel.logonType = this.preAuthenticationResponse.loginType;
      this.logonRequest.programmeShortCode = programmesShortCode;
      this.logonRequest.permissionType = PermissionType.user;
      let privateDataAsJson;
      let authenticationAsyncResponse;
      switch (this.preAuthenticationResponse.loginType) {
        case LogonTypeEnum.Email:
          if (validateEmail(this.privateDataModel.typeValue)) {
            if (!this.privateDataModel.typeValue) {
              Swal({ type: 'error', title: 'Logon failed: No email address present', showConfirmButton: false, timer: 2000 });
              break;
            }
            privateDataAsJson = JSON.stringify(this.privateDataModel);
            this.logonRequest.privateData = btoa(privateDataAsJson);
            // Todo: add the private-key to the auth request and save it if it doesn't exist
            this.blockUI.start('Logging you in.');
            authenticationAsyncResponse = await this._authenticationService.AuthenticationAsync(this.logonRequest);
            this.blockUI.stop();
            sessionStorage.setItem('private-key', authenticationAsyncResponse.privateKey);
            this.logonSuccessMessage(authenticationAsyncResponse);
          }
          break;
        case LogonTypeEnum.Mobile_Number:
          if (!this.privateDataModel.typeValue) {
            Swal({ type: 'error', title: 'Logon failed: No mobile number present', showConfirmButton: false, timer: 2000 });
            break;
          }
          this.privateDataModel.typeValue = this.privateDataModel.typeValue.replace(/[^A-Z0-9]+/gi, '');
          privateDataAsJson = JSON.stringify(this.privateDataModel);
          this.logonRequest.privateData = btoa(JSON.stringify(this.privateDataModel));
          this.blockUI.start('Logging you in.');
          authenticationAsyncResponse = await this._authenticationService.AuthenticationAsync(this.logonRequest);
          this.blockUI.stop();
          this.logonSuccessMessage(authenticationAsyncResponse);
          break;
        case LogonTypeEnum.Username:
          break;
        case LogonTypeEnum.SocialMedia:
          this.privateDataModel.socialMediaData = this.userData;
          break;
        default:
          break;
      }
    } else {
      // Hardcoded for now
      this.privateDataModel.logonType = LogonTypeEnum.Mobile_Number;
    }
  }
  async logonSuccessMessage(response: LogonResponse) {
    if (response.isLoggedOn) {
      sessionStorage.setItem(StorageConstants.loginDetails, JSON.stringify(response));
      sessionStorage.setItem('programID', response.usersModel.programmeId.toString());

      if (!this.partnerCode.includes('pvtk') && response.usersModel.programmeId === 2222) {
        this.logonRequest.programmeShortCode = 'scbn';
        // this.beansUser = await this._platformService.GetUsersModelByMobileNumberAsync(this.privateDataModel.typeValue, 2494);

        //console.log('beansUser: ');
        // console.log(this.beansUser);

        this.authenticationBeansAsyncResponse = await this._authenticationService.AuthenticationAsync(this.logonRequest);

        // const preAuthResponseBeans = this._preAuthenticationService.PreAuthenticationAsync('scbn');
        sessionStorage.setItem('loginBeansDetails', JSON.stringify(this.authenticationBeansAsyncResponse));
      }

      Swal({ type: 'success', title: 'Login successful', showConfirmButton: false, timer: 1500 });
      this._router.navigateByUrl('/dashboard');
    } else {
      Swal('Login failed:', response.customLogonMessage, 'error');
    }
  }
  onOK() {
    this._messageService.clear('logonFail');
    this.privateDataModel.password = '';
    this.privateDataModel.typeValue = '';
  }
  register() {
    this._router.navigateByUrl(`/register`);
  }
  async onForogtPassword() {
    const { value: mobileNumber } = await Swal({
            title: 'Enter mobile number to recover password',
            input: 'tel',
            inputPlaceholder: 'Mobile number'
          });
          if (mobileNumber) {
            const numberRegex = /0[0-9]{9}/;
            this.registerValue = mobileNumber;
            if (!numberRegex.test(this.registerValue)) {
              Swal('Entered number: ' + mobileNumber, 'Mobile number format not recognized.', 'error');
            }
            const registerRequestModel = new RegisterRequestModel();
            registerRequestModel.programmeId = this.preAuthenticationResponse.programId;
            registerRequestModel.logonType = this.preAuthenticationResponse.loginType;
            registerRequestModel.logonTypeValue = this.registerValue;
            registerRequestModel.resetPassword = true;
            registerRequestModel.permissionType = PermissionType.user;
            const response = await this._authenticationService.registerAsync(registerRequestModel);
            if (response.isSuccessful) {
              Swal('Entered number: ' + mobileNumber, response.customMessage, 'success');
            } else {
              Swal('Entered number: ' + mobileNumber, response.customMessage, 'error');
            }
          }
  }
  async socialSignIn(socialPlatform: string) {
    sessionStorage.setItem(StorageConstants.MediaAuthInit, 'true');
  }
  public googleInit() {
    gapi.load('auth2', () => {
      this.auth2 = gapi.auth2.getAuthInstance({
        client_id: this.settings.google,
        cookiepolicy: 'single_host_origin',
        scope: 'profile email'
      });
      this.attachSignin(document.getElementById('googleBtn'));
    });
  }
  public attachSignin(element) {
    this.auth2.attachClickHandler(
      element,
      {},
      googleUser => {
        const profile = googleUser.getBasicProfile();
        this.userData = {
          authToken: googleUser.getAuthResponse().login_hint,
          email: profile.getEmail(),
          firstName: profile.getGivenName(),
          id: profile.getId(),
          idToken: googleUser.getAuthResponse().id_token,
          lastName: profile.getFamilyName(),
          name: profile.getName(),
          photoUrl: profile.getImageUrl(),
          provider: 'GOOGLE'
        };
        this.SocialLogin();
      },
      error => {
        alert(JSON.stringify(error, undefined, 2));
      }
    );
  }
  private SocialLogin() {
    this.preAuthenticationResponse.loginType = LogonTypeEnum.SocialMedia;
    this.onLogin();
  }
  private createFBListener() {
    try {
      const context = this;
      FB.Event.subscribe('auth.statusChange', response => {
        if (response.status === 'connected') {
          const loginData = response;
          FB.api('/me?fields=email,name,friends,first_name,last_name', x => {
            context.userData = {
              authToken: loginData.authResponse.accessToken,
              email: x.email,
              firstName: x.first_name,
              id: x.id,
              idToken: loginData.authResponse.signedRequest,
              lastName: x.last_name,
              name: x.name,
              photoUrl: `http://graph.facebook.com/${x.id}/picture?type=normal`,
              provider: 'FACEBOOK'
            };

            this.SocialLogin();
          });
        }
      });
    } catch (e) {
      console.error(e);
    }
  }
  private InitFB() {
    try {
      (function(d, s, id) {
        let js;
        const fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = '//connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
      window.fbAsyncInit = () => {
        console.log('fbasyncinit');
        FB.init({
          appId: this.settings.facebook,
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v2.10'
        });
        FB.AppEvents.logPageView();
        this.createFBListener();
      };
    } catch (e) {
      console.error(e);
    }
  }
  @HostListener('document:keypress', ['$event'])
  async handleKeyboardEvent(event: KeyboardEvent) {
    if (event.code.toLowerCase() === 'numpadenter' || event.code.toLowerCase() === 'enter') {
      await this.onLogin();
    }
  }
  //#endregion Functions
}
